import { bounds } from './chunk-QF7HVQZZ.js';

// src/split.ts
var Split = class {
  constructor(el) {
    this.el = el;
    this.html = this.el.innerHTML;
    this.tokens = [];
    this.tokenCount = 0;
    const normalised = this.html.replaceAll("</i> <i>", " ");
    const staging = document.createElement("div");
    staging.innerHTML = normalised;
    const nodes = staging.childNodes;
    const nodeLength = nodes.length;
    const tokens = [];
    let tokenIndex = 0;
    for (let nIdx = 0; nIdx < nodeLength; nIdx++) {
      const node = nodes[nIdx];
      if (node?.nodeType === Node.TEXT_NODE) {
        const words = node.nodeValue?.split(" ") ?? [];
        const wordCount = words.length;
        for (let wordIdx = 0; wordIdx < wordCount; wordIdx++) {
          const raw = words[wordIdx];
          tokens[tokenIndex++] = {
            type: "txt",
            word: raw === "" ? " " : raw ?? ""
          };
        }
        continue;
      }
      const element = node;
      if (element?.tagName === "BR") {
        tokens[tokenIndex++] = { type: "br" };
        continue;
      }
      if (element?.tagName === "A" || element?.tagName === "I") {
        const outerHTML = element.outerHTML;
        const innerHTML = element.innerHTML;
        const [start, end] = outerHTML.split(`>${innerHTML}<`);
        tokens[tokenIndex++] = {
          type: "tag",
          start: `${start ?? ""}>`,
          end: `<${end ?? ""}`,
          word: innerHTML.split(" ")
        };
      }
    }
    this.tokens = tokens;
    this.tokenCount = tokens.length;
  }
  resize(opts) {
    this.el.innerHTML = this.html;
    const mode = opts.mode || "auto";
    if (mode === "br") {
      const lines2 = [];
      let lineCount2 = 0;
      let renderedLine2 = "";
      for (let idx = 0; idx < this.tokenCount; idx++) {
        const token = this.tokens[idx];
        if (!token) continue;
        if (token.type === "txt") {
          const word = token.word;
          const separator = word === " " ? "" : " ";
          renderedLine2 += word + separator;
          continue;
        }
        if (token.type === "tag") {
          const { start: start3, end: end3, word } = token;
          const inner = word.join(" ");
          renderedLine2 += start3 + inner + end3;
          continue;
        }
        if (token.type === "br") {
          lines2[lineCount2++] = renderedLine2.trim();
          renderedLine2 = "";
        }
      }
      const finalLine2 = renderedLine2.trim();
      if (finalLine2 && finalLine2 !== lines2[lineCount2 - 1]) {
        lines2[lineCount2++] = finalLine2;
      }
      const { start: start2, end: end2 } = opts.tag;
      let output2 = "";
      for (let idx = 0; idx < lineCount2; idx++) {
        const segment = lines2[idx] === "" ? "&nbsp;" : lines2[idx];
        output2 += start2 + segment + end2;
      }
      this.el.innerHTML = output2;
      return;
    }
    const maxWidth = this.measure(this.el);
    const probe = document.createElement("div");
    const probeStyle = probe.style;
    probeStyle.visibility = "hidden";
    probeStyle.position = "absolute";
    probeStyle.whiteSpace = "nowrap";
    const computed = getComputedStyle(this.el);
    probeStyle.fontFamily = computed.fontFamily;
    probeStyle.fontSize = computed.fontSize;
    probeStyle.fontWeight = computed.fontWeight;
    probeStyle.letterSpacing = computed.letterSpacing;
    probe.className = "_sl";
    document.body.prepend(probe);
    const textIndent = parseInt(computed.textIndent, 10);
    const hasIndent = textIndent > 0;
    let availableWidth = maxWidth;
    let allowIndent = true;
    if (hasIndent) {
      availableWidth -= textIndent;
      allowIndent = false;
    }
    const lines = [];
    let lineCount = 0;
    let probePrefix = "";
    let renderedLine = "";
    for (let idx = 0; idx < this.tokenCount; idx++) {
      const token = this.tokens[idx];
      if (hasIndent && !allowIndent && lineCount > 0) {
        allowIndent = true;
        availableWidth += textIndent;
      }
      if (token?.type === "txt") {
        const word = token.word;
        const separator = word === " " ? "" : " ";
        probe.innerHTML = probePrefix + word;
        if (this.measure(probe) > availableWidth) {
          lines[lineCount++] = renderedLine.trim();
          probePrefix = word + separator;
          renderedLine = word + separator;
        } else {
          probePrefix += word + separator;
          renderedLine += word + separator;
        }
        continue;
      }
      if (token?.type === "tag") {
        const { start: start2, end: end2, word } = token;
        const lastWordIndex = word.length - 1;
        probePrefix = this.trimEnd(probePrefix);
        renderedLine = this.trimEnd(renderedLine);
        let accumulator = "";
        for (let wordIdx = 0; wordIdx < word.length; wordIdx++) {
          const suffix = wordIdx === lastWordIndex ? "" : " ";
          const currentWord = word[wordIdx] ?? "";
          accumulator += currentWord;
          probe.innerHTML = probePrefix + start2 + accumulator + end2;
          if (this.measure(probe) > availableWidth) {
            if (wordIdx === 0) {
              lines[lineCount++] = renderedLine.trim();
            } else {
              renderedLine = renderedLine.trim() + end2;
              lines[lineCount++] = renderedLine;
            }
            probePrefix = "";
            accumulator = currentWord + suffix;
            renderedLine = wordIdx === lastWordIndex ? start2 + currentWord + end2 + suffix : start2 + currentWord + suffix;
          } else {
            accumulator += suffix;
            let append = currentWord;
            if (wordIdx === 0) append = start2 + append;
            if (wordIdx === lastWordIndex) append += end2;
            renderedLine += append + suffix;
          }
          if (wordIdx === lastWordIndex)
            probePrefix += start2 + accumulator + end2;
        }
        continue;
      }
      if (token?.type === "br") {
        lines[lineCount++] = renderedLine.trim();
        probePrefix = "";
        renderedLine = "";
      }
    }
    const finalLine = renderedLine.trim();
    if (finalLine && finalLine !== lines[lineCount - 1]) {
      lines[lineCount++] = finalLine;
    }
    const { start, end } = opts.tag;
    let output = "";
    for (let idx = 0; idx < lineCount; idx++) {
      const segment = lines[idx] === "" ? "&nbsp;" : lines[idx];
      output += start + segment + end;
    }
    if (probe.parentNode) {
      probe.parentNode.removeChild(probe);
    }
    this.el.innerHTML = output;
  }
  trimEnd(value) {
    return value.replace(/\s?$/, "");
  }
  measure(node) {
    return bounds(node).width;
  }
};
var split_default = Split;

export { Split, split_default };
//# sourceMappingURL=chunk-TFEI6CXR.js.map
//# sourceMappingURL=chunk-TFEI6CXR.js.map